import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/constants";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    const run = async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: res.data } });
      } catch {
        navigate("/admin", { replace: true });
      }
    };
    if (sessionId) run();
    else navigate("/admin", { replace: true });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#090A0F]">
      <img src={LOGO_URL} alt="LUHAI" className="h-10 mb-6 opacity-90" />
      <div className="h-8 w-8 rounded-full border-2 border-[#02AACF] border-t-transparent animate-spin" />
      <p className="text-[#94A3B8] mt-4 text-sm font-mono2">Signing you in…</p>
    </div>
  );
}
